import React from "react";

const TempleGridFlexInformation = () => {
  return (
    <div>
      <div>
        create bubbles
        <div>use bubbles to make cool images</div>
        <div> never stop dancing</div>
      </div>
    </div>
  );
};

export default TempleGridFlexInformation;
